namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoItem5Service {
        export const baseUrl = 'AdvPromo/PsAdvPromoItem5';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoItem5Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoItem5Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoItem5Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoItem5Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoItem5/Create",
            Update = "AdvPromo/PsAdvPromoItem5/Update",
            Delete = "AdvPromo/PsAdvPromoItem5/Delete",
            Retrieve = "AdvPromo/PsAdvPromoItem5/Retrieve",
            List = "AdvPromo/PsAdvPromoItem5/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoItem5Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
